// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarArquivoByFileNameService = async (fileName: string) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/arquivo/${fileName}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
        responseType: "blob",
      });

      if (response && response.data) {
        return response.data;

        // Retorna true se tudo correr bem e o array não estiver vazio
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
